import type { BillingProfileDomainQueryModel } from '@mntn-dev/domain-types'

export function billingProfileHasAms(
  billingProfile: BillingProfileDomainQueryModel
) {
  return billingProfile.ams
}
